interface UsedCard {
    stripe_customer_id: string,
    payment_method_id: string,
    last4: string,
    use_old_card: boolean,
}

interface UserRole {
    value: string
}

interface UserData {
    distributor_code: string;
    available_features: FeaturesUser;
    user_role: UserRole
}

interface FeaturesUser {
    feature_defaulter_user: boolean;
    feature_contract_is_going_to_finish: boolean;
    feature_trial_contract_is_finished: boolean;
    feature_bank_contract_finished: boolean;
    feature_bank_contract_is_going_to_finish: boolean;
    feature_bank_trial_contract_is_finished: boolean;
    feature_show_triangle_contracts: boolean;
    feature_can_buy_facturae: boolean;
    feature_purchase_extra_users: boolean;
    feature_clock_in: boolean;
    feature_working_hours_contract_is_going_to_finish: boolean;
    feature_working_hours_trial_contract_is_finished: boolean;
    feature_working_hours_contract_finished: boolean;
}

interface Taxes {
    name: string;
    percentage: number;
    added: boolean;
}

interface Service {
    dropdown: boolean,
    selected_plan_name: string,
    service_id: number,
    price: number,
    is_auto_renewal_active: boolean,
    name_plan_info_extra_users: string,
}

interface SelectedService {
    documents: Service
    banks: Service
    credits: Service
    facturae_credits: Service
    working_hours: Service
}

interface ExtraUsersData {
    documents: ExtraUserInfo
    banks: ExtraUserInfo
    facturae_credits: ExtraUserInfo
    credits: ExtraUserInfo
    working_hours: ExtraUserInfo
}

interface ExtraUserInfo {
    show: boolean
    paid_extra_users: number
    selected_extra_users: number
    extra_users_num: number
    extra_users_price: number
    friendly: string
    validation_error: string
}

export class ContractPopup{
    show_contract_modal: boolean;
    user_data: UserData;
    contract_modal_msg: string;
    contract_modal_distributor: boolean;
    contract_modal_facturae_client: boolean;
    contract_modal_working_hours_client: boolean;
    is_company_selector_visible: boolean;
    is_tax_data_filled: boolean;
    can_show_document_services_and_banks: boolean;
    user_companies: Array<any>;
    selected_company_id: number;
    message_listener: any;
    card_title: string;
    default_waiting_time: number; // 5 minutes in seconds
    waiting_time: number;
    used_card: UsedCard;
    title: string;
    message: string;
    success: boolean;
    file_added: boolean;
    any_plan_selected: boolean;
    isSummaryDisplayed: boolean;
    is_auto_renewal_displayed: boolean;
    payment_method: string;
    companies_eInvoice: number;
    view: string;
    selected_services: SelectedService;
    services: Object;
    num_credits_custom: number;
    payment_file: File;
    is_the_contract_accepted: boolean;
    distributor_users: Array<any>;
    user_id_to_deliver_contract: number;
    client_users_facturae: Array<any>; // supongo que se quedo a medias
    user_id_to_deliver_facturae: number; // supongo que se quedo a medias
    taxes: Taxes;
    promotional_code: string;
    error_message_for_promotional_code: string;
    success_message_for_promotional_code: string;
    key_promotional_code: number;
    timer_interval_id: ReturnType<typeof setInterval>;;
    contract_date: string;
    end_date: string;
    total_price: number;
    extraUsersScreenData: ExtraUsersData;
    is_services_loading: boolean;
    is_open_info_extra_companies: boolean;
    is_open_info_extra_users: boolean;
    
    constructor(){
        this.show_contract_modal = true
        this.user_data = {
            distributor_code: "",
            available_features: {
                feature_defaulter_user: false,
                feature_contract_is_going_to_finish: false,
                feature_trial_contract_is_finished: false,
                feature_bank_contract_finished: false,
                feature_bank_contract_is_going_to_finish: false,
                feature_bank_trial_contract_is_finished: false,
                feature_show_triangle_contracts: false,
                feature_can_buy_facturae: false,
                feature_purchase_extra_users: false,
                feature_clock_in: false,
                feature_working_hours_contract_is_going_to_finish: false,
                feature_working_hours_trial_contract_is_finished: false,
                feature_working_hours_contract_finished: false,
            },
            user_role: {
                value: "",
            },
        };
        this.contract_modal_msg = '';
        this.contract_modal_distributor = false;
        this.contract_modal_facturae_client = false;
        this.contract_modal_working_hours_client = false;
        this.is_company_selector_visible = false;
        this.is_tax_data_filled = false;
        this.can_show_document_services_and_banks = false;
        this.user_companies = [];
        this.selected_company_id = null;
        this.message_listener = null;
        this.card_title = "Selecciona el plan anual que quieres contratar";
        this.default_waiting_time = 300; // 5 minutes in seconds
        this.waiting_time = 0;
        this.used_card = {
            stripe_customer_id: null,
            payment_method_id: null,
            last4: null,
            use_old_card: false,
        };
        this.title = '';
        this.message = '';
        this.success = false;
        this.file_added = false;
        this.any_plan_selected = false;
        this.isSummaryDisplayed = true;
        this.is_auto_renewal_displayed = false;
        this.payment_method = "transfer";
        this.companies_eInvoice = 5;
        this.view = "select_plan";
        this.selected_services = {
            'documents': {
                dropdown: false,
                selected_plan_name: '',
                service_id: null,
                price: 0,
                is_auto_renewal_active: false,
                name_plan_info_extra_users: "",
            },
            'banks': {
                dropdown: false,
                selected_plan_name: '',
                service_id: null,
                price: 0,
                is_auto_renewal_active: false,
                name_plan_info_extra_users: "",
            },
            'credits': {
                dropdown: false,
                selected_plan_name: '',
                service_id: null,
                price: 0,
                is_auto_renewal_active: false,
                name_plan_info_extra_users: "",
            },
            'facturae_credits': {
                dropdown: false,
                selected_plan_name: '',
                service_id: null,
                price: 0,
                is_auto_renewal_active: false,
                name_plan_info_extra_users: "",
            },
            'working_hours': {
                dropdown: false,
                selected_plan_name: '',
                service_id: null,
                price: 0,
                is_auto_renewal_active: false,
                name_plan_info_extra_users: "",
            },
        };
        this.services = {
            documents: [], 
            banks: [], 
            credits: [], 
            facturae_credits: []
        };
        this.num_credits_custom = 5;
        this.payment_file = null;
        this.is_the_contract_accepted = false;
        this.distributor_users = [];
        this.user_id_to_deliver_contract = null;
        this.client_users_facturae = []; // supongo que se quedo a medias
        this.user_id_to_deliver_facturae = null; // supongo que se quedo a medias
        this.taxes = {
            name: null,
            percentage: null,
            added: null,
        };
        this.promotional_code = "";
        this.error_message_for_promotional_code = "";
        this.success_message_for_promotional_code = "";
        this.key_promotional_code = 0;
        this.timer_interval_id = null;
        this.contract_date = "";
        this.end_date = "";
        this.total_price = 0;
        this.extraUsersScreenData = {
                documents: { show: false, paid_extra_users: null, selected_extra_users: null, extra_users_num: null, extra_users_price: null, friendly:"Facturas", validation_error: null },
                banks: { show: false, paid_extra_users: null, selected_extra_users: null, extra_users_num: null, extra_users_price: null, friendly:"Bancos", validation_error: null },
                facturae_credits: { show: false, paid_extra_users: null, selected_extra_users: null, extra_users_num: null, extra_users_price: null, friendly:"Factura electrónica", validation_error: null },
                credits: { show: false, paid_extra_users: null, selected_extra_users: null, extra_users_num: null, extra_users_price: null, friendly:"Gestor documental", validation_error: null },
                working_hours: { show: false, paid_extra_users: null, selected_extra_users: null, extra_users_num: null, extra_users_price: null, friendly:"Fichaje", validation_error: null },
        }
        this.is_services_loading = false;
        this.is_open_info_extra_companies = false;
        this.is_open_info_extra_users = false;
    }
}